'use es6';

import { ActionTypes } from '../constants/AppConstants';
import Immutable from 'immutable';
var defaultState = new Immutable.Map({
  domain: null,
  loading: true
});

var Grader = function Grader() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.RESULTS_PAGE_UNMOUNTED:
      return state.merge({
        loading: true
      });

    case ActionTypes.WEBSITE_GRADED:
      return state.merge(action.payload).merge({
        loading: false
      });

    case ActionTypes.WEBSITE_GRADED_ERROR:
      {
        var websiteUrl = action.payload.websiteUrl;
        return state.merge({
          domain: websiteUrl
        });
      }

    default:
      return state;
  }
};

export default Grader;